import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppSettings } from 'src/app/utils/app-settings';
import { Error } from '../../../../models/error';
import { PickupAssistant } from '../models/pickup-assistant';

@Injectable({
  providedIn: 'root'
})
export class PickupAssistantService {

  constructor(private http: HttpClient) { }
  public force_reload_photo = false;

  private _cache: Array<PickupAssistant>;

  public getPickupAssistantsForStudent(): Observable<Array<PickupAssistant>> {
    if (this._cache) {
      return of(this._cache);
    }
    return this.http.get<Array<PickupAssistant>>(`${AppSettings.apiUrl}pickupassistant`)
      .pipe(
        tap(res => {
          this._cache = res;
        })
      );
  }
  public updatePhoto(id: number, file: File) {
    if (file) {
      this._cache = null;
      this.force_reload_photo = true;
      let formData: FormData = new FormData();
      formData.append('photo', file, file.name);
      if (id) {
        return this.http.patch(`${AppSettings.apiUrl}pickupassistant/${id}/photo`, formData).pipe(
          catchError(err => {
            if (err.status == 413) {
              let errObj = new Error();
              errObj.status = err.status;
              errObj.statusText = err.statusText;
              errObj.message = "Please upload only files of size less than 10MB";
              return of(errObj);
            }
            throwError(err);
          })
        );
      } else {
        return this.http.post(`${AppSettings.apiUrl}files/`, formData).pipe(
          catchError(err => {
            if (err.status == 413) {
              let errObj = new Error();
              errObj.status = err.status;
              errObj.statusText = err.statusText;
              errObj.message = "Please upload only files of size less than 10MB";
              return of(errObj);
            }
            throwError(err);
          })
        );
      }
    }
    else {
      return of(null);
    }
  }
  public update(pickupassistant: PickupAssistant): Observable<PickupAssistant> {
    this._cache = null;
    if (pickupassistant.pickup_assistant_id) {
      return this.http.put<PickupAssistant>(`${AppSettings.apiUrl}pickupassistant/${pickupassistant.pickup_assistant_id}/`, pickupassistant);
    }
    return this.http.post<PickupAssistant>(`${AppSettings.apiUrl}pickupassistant/`, pickupassistant);
  }

  public delete(id: number) {
    this._cache = null;
    return this.http.delete(`${AppSettings.apiUrl}pickupassistant/${id}/`);
  }
}
